export default "/images/codepen.svg?4a048dd62b63bb3ee66818b169db544d";